import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */

const SvgWebsite = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 4a8 8 0 110 16 8 8 0 010-16zm-1.886 1.778A6.518 6.518 0 006.232 9h2.986c.193-1.268.503-2.375.896-3.222zM5.5 12c0-.518.06-1.021.175-1.504.025.003.05.004.075.004h3.303a21.169 21.169 0 00.042 3.5H5.813a6.496 6.496 0 01-.313-2zm1.022 3.5a6.515 6.515 0 003.592 2.722c-.34-.734-.619-1.662-.812-2.722h-2.78zm4.307 0c.122.601.274 1.151.454 1.63.214.57.451.997.672 1.246l.046.054-.044.052-.002.006h.09a.033.033 0 00-.006-.014L12 18.43l.044-.054c.22-.249.458-.676.672-1.246.18-.479.332-1.029.454-1.63h-2.34zm3.87 0c-.194 1.06-.473 1.988-.813 2.722a6.515 6.515 0 003.592-2.722h-2.78zm3.487-1.5h-3.28a21.205 21.205 0 00.042-3.5h3.302c.025 0 .05-.001.075-.004A6.518 6.518 0 0118.186 14zm-4.788 0h-2.796a19.644 19.644 0 01-.045-3.5h2.886a19.644 19.644 0 01-.045 3.5zm1.384-5h2.986a6.517 6.517 0 00-3.882-3.222c.393.847.703 1.954.896 3.222zm-3.499-2.13A11.543 11.543 0 0010.737 9h2.526a11.543 11.543 0 00-.546-2.13c-.214-.57-.451-.997-.672-1.246L12 5.57l.039-.045.006-.014h-.09c0 .003.002.008.006.013L12 5.57l-.045.053c-.22.249-.458.676-.672 1.246z"
      clipRule="evenodd"
    />
  </svg>
));
SvgWebsite.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgWebsite;
